<div class="container-table">
  <div class="container-top border border-gray-150 bg-gray-50 px-4 py-3">
    <div
      class="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center sm:justify-end sm:gap-3"
    >
      <button
        type="button"
        class="btn-secondary !h-10 w-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 sm:w-auto"
        (click)="clearFilter()"
      >
        Clear Filters
      </button>
      <button
        type="button"
        class="btn-primary !h-10 w-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 sm:w-auto"
        (click)="toggleFilters()"
        [attr.aria-expanded]="showFilters"
        aria-controls="filter-rows"
      >
        {{ showFilters ? 'Hide Filters' : 'Show Filters' }}
      </button>
    </div>
  </div>

  <section class="table-unm border border-t-0 border-gray-150 bg-white" aria-label="Metric details data table">
    <div class="min-h-75 overflow-x-auto">
      <!-- Angular Material Table -->
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        [attr.aria-label]="'Metric details by ' + tableDimension"
      >
        <!-- Suppressed Column -->
        <ng-container matColumnDef="Suppressed">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            Suppressed
          </th>
          <td mat-cell *matCellDef="let product" data-label="Suppressed">{{ true }}</td>
        </ng-container>

        <!-- Account Column -->
        <ng-container matColumnDef="device_name">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            Edge Name
          </th>
          <td mat-cell *matCellDef="let product" data-label="Edge Name">
            {{ product.device_name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="deviceNameFilter">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="table-header-th px-[2.5px]"
          >
            <input
              matInput
              (keyup)="applyFilter($event, 'device_name')"
              placeholder="Filter Edge Name"
              aria-label="Filter Edge Name"
              class="m-0 box-border w-full min-w-30 max-w-full rounded-none border border-gray-150 py-1.75 pl-2.5 pr-0 text-[13px] font-normal text-black hover:bg-gray-50 focus:border-blue-500 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500 sm:max-w-55"
              [(ngModel)]="filterValues.device_name"
            />
          </th>
        </ng-container>

        <ng-container matColumnDef="deviceNameFilter2">
          <th mat-header-cell *matHeaderCellDef class="px-[2.5px]"></th>
        </ng-container>

        <!-- Link Column -->
        <ng-container matColumnDef="link_name">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            Link Name
          </th>
          <td mat-cell *matCellDef="let product" data-label="Link Name">{{ product.link_name }}</td>
        </ng-container>

        <ng-container matColumnDef="linkNameFilter">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="table-header-th px-[2.5px]"
          >
            <input
              matInput
              (keyup)="applyFilter($event, 'link_name')"
              placeholder="Filter Link Name"
              aria-label="Filter Link Name"
              class="m-0 box-border w-full min-w-30 max-w-full rounded-none border border-gray-150 py-1.75 pl-2.5 pr-0 text-[13px] font-normal text-black hover:bg-gray-50 focus:border-blue-500 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500 sm:max-w-55"
              [(ngModel)]="filterValues.link_name"
            />
          </th>
        </ng-container>

        <ng-container matColumnDef="linkNameFilter2">
          <th mat-header-cell *matHeaderCellDef class="px-[2.5px]"></th>
        </ng-container>

        <!-- Application Column -->
        <ng-container matColumnDef="application">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            Application
          </th>
          <td mat-cell *matCellDef="let product" data-label="Application">
            {{ product.application }}
          </td>
        </ng-container>

        <ng-container matColumnDef="applicationFilter">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="table-header-th px-[2.5px]"
          >
            <input
              matInput
              (keyup)="applyFilter($event, 'application')"
              placeholder="Filter Application"
              aria-label="Filter Application"
              class="m-0 box-border w-full min-w-30 max-w-full rounded-none border border-gray-150 py-1.75 pl-2.5 pr-0 text-[13px] font-normal text-black hover:bg-gray-50 focus:border-blue-500 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500 sm:max-w-55"
              [(ngModel)]="filterValues.application"
            />
          </th>
        </ng-container>

        <ng-container matColumnDef="applicationFilter2">
          <th mat-header-cell *matHeaderCellDef class="px-[2.5px]"></th>
        </ng-container>

        <!-- Interface Name Column -->
        <ng-container matColumnDef="source">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            Data Source
          </th>
          <td mat-cell *matCellDef="let product" data-label="Data Source">{{ product.source }}</td>
        </ng-container>

        <ng-container matColumnDef="sourceFilter">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="table-header-th px-[2.5px]"
          >
            <input
              matInput
              (keyup)="applyFilter($event, 'source')"
              placeholder="Filter Source"
              aria-label="Filter Source"
              class="m-0 box-border w-full min-w-30 max-w-full rounded-none border border-gray-150 py-1.75 pl-2.5 pr-0 text-[13px] font-normal text-black hover:bg-gray-50 focus:border-blue-500 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500 sm:max-w-55"
              [(ngModel)]="filterValues.source"
            />
          </th>
        </ng-container>

        <ng-container matColumnDef="sourceFilter2">
          <th mat-header-cell *matHeaderCellDef class="px-[2.5px]"></th>
        </ng-container>

        <!-- Timestamp Column -->
        <ng-container matColumnDef="time_frame">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            Timestamp
          </th>
          <td mat-cell *matCellDef="let product" data-label="Timestamp">{{ product.time_frame }}</td>
        </ng-container>

        <ng-container matColumnDef="timeframeFilter">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="table-header-th px-[2.5px]"
          >
            <div class="flex w-full flex-wrap items-center gap-x-0 gap-y-1 sm:w-auto sm:gap-1.25">
              <!-- Start Date Picker -->
              <input
                matInput
                [matDatepicker]="startDatePicker"
                [(ngModel)]="filterValues.startDate"
                (dateChange)="applyDateFilter()"
                placeholder="Start Date"
                aria-label="Filter start date"
                class="m-0 box-border w-full min-w-0 max-w-[calc(100%-2.5rem)] flex-1 rounded-none border border-gray-150 py-1.75 pl-2.5 pr-0 text-[13px] font-normal text-black hover:bg-gray-50 focus:border-blue-500 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500 sm:min-w-30 sm:max-w-55 sm:flex-none"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="startDatePicker"
                class="ml-0 flex flex-none basis-10 items-center justify-center sm:-ml-12 sm:basis-auto"
              />
              <mat-datepicker #startDatePicker />

              <!-- Start Time Picker -->
              <input
                matInput
                [ngxMatTimepicker]="startTimePicker"
                [(ngModel)]="filterValues.startTime"
                placeholder="Start Time"
                aria-label="Filter start time"
                class="m-0 box-border w-full min-w-0 max-w-[calc(100%-2.5rem)] flex-1 rounded-none border border-gray-150 py-1.75 pl-2.5 pr-0 text-[13px] font-normal text-black hover:bg-gray-50 focus:border-blue-500 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500 sm:min-w-30 sm:max-w-55 sm:flex-none"
                (ngModelChange)="applyDateFilter()"
              />
              <ngx-mat-timepicker-toggle
                matSuffix
                [for]="startTimePicker"
                class="ml-0 flex flex-none basis-10 items-center justify-center sm:-ml-12 sm:basis-auto"
              />
              <ngx-mat-timepicker #startTimePicker />
            </div>
          </th>
        </ng-container>

        <ng-container matColumnDef="timeframeFilter2">
          <th mat-header-cell *matHeaderCellDef class="table-header-th px-[2.5px]">
            <div class="flex w-full flex-wrap items-center gap-x-0 gap-y-1 sm:w-auto sm:gap-1.25">
              <!-- End Date Picker -->
              <input
                matInput
                [matDatepicker]="endDatePicker"
                [(ngModel)]="filterValues.endDate"
                (dateChange)="applyDateFilter()"
                placeholder="End Date"
                aria-label="Filter end date"
                class="m-0 box-border w-full min-w-0 max-w-[calc(100%-2.5rem)] flex-1 rounded-none border border-gray-150 py-1.75 pl-2.5 pr-0 text-[13px] font-normal text-black hover:bg-gray-50 focus:border-blue-500 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500 sm:min-w-30 sm:max-w-55 sm:flex-none"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="endDatePicker"
                class="ml-0 flex flex-none basis-10 items-center justify-center sm:-ml-12 sm:basis-auto"
              ></mat-datepicker-toggle>
              <mat-datepicker #endDatePicker></mat-datepicker>

              <!-- End Time Picker -->
              <input
                matInput
                [ngxMatTimepicker]="endTimePicker"
                [(ngModel)]="filterValues.endTime"
                placeholder="End Time"
                aria-label="Filter end time"
                class="m-0 box-border w-full min-w-0 max-w-[calc(100%-2.5rem)] flex-1 rounded-none border border-gray-150 py-1.75 pl-2.5 pr-0 text-[13px] font-normal text-black hover:bg-gray-50 focus:border-blue-500 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500 sm:min-w-30 sm:max-w-55 sm:flex-none"
                (ngModelChange)="applyDateFilter()"
              />
              <ngx-mat-timepicker-toggle
                matSuffix
                [for]="endTimePicker"
                class="ml-0 flex flex-none basis-10 items-center justify-center sm:-ml-12 sm:basis-auto"
              />
              <ngx-mat-timepicker #endTimePicker />
            </div>
          </th>
        </ng-container>

        <!-- Latency (ms) Column -->
        <ng-container matColumnDef="latency">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            Latency (ms)
          </th>
          <td mat-cell *matCellDef="let product" data-label="Latency (ms)">{{ product.latency }}</td>
        </ng-container>

        <ng-container matColumnDef="latencyFilter">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="table-header-th px-[2.5px]"
          >
            <input
              matInput
              (keyup)="applyFilter($event, 'latency')"
              placeholder="Filter Latency"
              aria-label="Filter Latency"
              class="m-0 box-border w-full min-w-30 max-w-full rounded-none border border-gray-150 py-1.75 pl-2.5 pr-0 text-[13px] font-normal text-black hover:bg-gray-50 focus:border-blue-500 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500 sm:max-w-55"
              [(ngModel)]="filterValues.latency"
            />
          </th>
        </ng-container>

        <ng-container matColumnDef="latencyFilter2">
          <th mat-header-cell *matHeaderCellDef class="px-[2.5px]"></th>
        </ng-container>

        <!-- Jitter (ms) Column -->
        <ng-container matColumnDef="jitter">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            Jitter (ms)
          </th>
          <td mat-cell *matCellDef="let product" data-label="Jitter (ms)">{{ product.jitter }}</td>
        </ng-container>

        <ng-container matColumnDef="jitterFilter">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="table-header-th px-[2.5px]"
          >
            <input
              matInput
              (keyup)="applyFilter($event, 'jitter')"
              placeholder="Filter Jitter"
              aria-label="Filter Jitter"
              class="m-0 box-border w-full min-w-30 max-w-full rounded-none border border-gray-150 py-1.75 pl-2.5 pr-0 text-[13px] font-normal text-black hover:bg-gray-50 focus:border-blue-500 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500 sm:max-w-55"
              [(ngModel)]="filterValues.jitter"
            />
          </th>
        </ng-container>

        <ng-container matColumnDef="jitterFilter2">
          <th mat-header-cell *matHeaderCellDef class="px-[2.5px]"></th>
        </ng-container>

        <!-- Packet Loss Column -->
        <ng-container matColumnDef="packet_loss">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            Packet Loss (%)
          </th>
          <td mat-cell *matCellDef="let product" data-label="Packet Loss (%)">
            {{ product.packet_loss }}
          </td>
        </ng-container>

        <ng-container matColumnDef="packetLossFilter">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="table-header-th px-[2.5px]"
          >
            <input
              matInput
              (keyup)="applyFilter($event, 'packet_loss')"
              placeholder="Filter Packet Loss"
              aria-label="Filter Packet Loss"
              class="m-0 box-border w-full min-w-30 max-w-full rounded-none border border-gray-150 py-1.75 pl-2.5 pr-0 text-[13px] font-normal text-black hover:bg-gray-50 focus:border-blue-500 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500 sm:max-w-55"
              [(ngModel)]="filterValues.packet_loss"
            />
          </th>
        </ng-container>

        <ng-container matColumnDef="packetLossFilter2">
          <th mat-header-cell *matHeaderCellDef class="px-[2.5px]"></th>
        </ng-container>

        <!-- Data Utilization Column -->
        <ng-container matColumnDef="data_utilization">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            Data Utilization (%)
          </th>
          <td mat-cell *matCellDef="let product" data-label="Data Utilization (%)">
            {{ product.data_utilization }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dataUtilizationFilter">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="table-header-th px-[2.5px]"
          >
            <input
              matInput
              (keyup)="applyFilter($event, 'data_utilization')"
              placeholder="Filter Data Utilization"
              aria-label="Filter Data Utilization"
              class="m-0 box-border w-full min-w-30 max-w-full rounded-none border border-gray-150 py-1.75 pl-2.5 pr-0 text-[13px] font-normal text-black hover:bg-gray-50 focus:border-blue-500 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500 sm:max-w-55"
              [(ngModel)]="filterValues.data_utilization"
            />
          </th>
        </ng-container>

        <ng-container matColumnDef="dataUtilizationFilter2">
          <th mat-header-cell *matHeaderCellDef class="px-[2.5px]"></th>
        </ng-container>

        <!-- Data Usage (MB) Column -->
        <ng-container matColumnDef="data_usage">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            Data Usage (MB)
          </th>
          <td mat-cell *matCellDef="let product" data-label="Data Usage (MB)">
            {{ product.data_usage | number: '1.2-2' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dataUsageFilter">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="table-header-th px-[2.5px]"
          >
            <input
              matInput
              (keyup)="applyFilter($event, 'data_usage')"
              placeholder="Filter Data Usage"
              aria-label="Filter Data Usage"
              class="m-0 box-border w-full min-w-30 max-w-full rounded-none border border-gray-150 py-1.75 pl-2.5 pr-0 text-[13px] font-normal text-black hover:bg-gray-50 focus:border-blue-500 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500 sm:max-w-55"
              [(ngModel)]="filterValues.data_usage"
            />
          </th>
        </ng-container>

        <ng-container matColumnDef="dataUsageFilter2">
          <th mat-header-cell *matHeaderCellDef class="px-[2.5px]"></th>
        </ng-container>

        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="column-headers"></tr>
        <tr
          mat-header-row
          *matHeaderRowDef="filters"
          class="filter-row"
          [class.hidden-row]="!showFilters"
        ></tr>
        <tr
          mat-header-row
          *matHeaderRowDef="filters2"
          class="filter-row"
          [class.hidden-row]="!showFilters"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- No Data Message -->

        <tr *matNoDataRow [hidden]="loading">
          <td [attr.colspan]="displayedColumns.length" class="h-full min-h-25">
            <div class="py-5 text-center text-xl">No data available to display.</div>
          </td>
        </tr>
      </table>

      @if (loading) {
        <div class="mt-5 flex h-full min-h-50 items-center justify-center" role="status" aria-live="polite">
          <mat-spinner [diameter]="50" aria-label="Loading metric details"></mat-spinner>
          <span class="sr-only">Loading metric details</span>
        </div>
      }
      <!-- Pagination Controls -->
      <mat-paginator
        showFirstLastButtons
        [pageSize]="defaultPageSizeOption"
        [pageSizeOptions]="pageSizeOptions"
        aria-label="Table pagination"
      ></mat-paginator>
    </div>
  </section>
</div>

